import React from 'react';
import styled from 'styled-components';
import UserForm from '../containers/UserForm';
import Footer from '../containers/Footer';
import Isologo from '../assets/isologo.svg';
import withAuthAndData from '../components/withAuthAndData';
import LeadGenValidation from '../components/LeadGenValidation';
import { useLeadGen } from '../hooks/useLeadGen';

const Wrapper = styled.div`
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 36px;
  margin-top: 50px;
  
  padding-bottom: 100px;
  

  @media (orientation: portrait) and (max-width: 767px) {
    margin-top: 20px;
  }
`;

const TopLineWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TopLineTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const TopLineTitle = styled.h2`
  font-size: 24px;
  line-height: 24px;
  color: #000000;
  margin: 0;
  margin-bottom: 5px;
  font-weight: 500;
`;

const TopLineSubtitle = styled.h3`
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.basic1000};
  font-weight: 300;
  margin: 0;
`;

const Wallet = styled.img`
  width: 80px;
  height: 71px;
`;

const MainTitle = styled.h1`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.background};
  font-weight: 700;
  margin: 8px 0;
`;

const Disclaimer = styled.p`
  margin-top: 30px;
  font-size: 11px;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.basic1000};
  font-weight: 300;
  text-align: justify;
`;

const Home = () => {
  const {
    showValidation,
    leadGenHash,
    handleValidationSuccess,
    handleValidationError
  } = useLeadGen();

  return (
    <Wrapper>
      <TopLineWrapper>
        <TopLineTextWrapper>
          <TopLineTitle>¡Te presto más rápido y 100% online!</TopLineTitle>
          <TopLineSubtitle></TopLineSubtitle>
        </TopLineTextWrapper>
        <Wallet src={Isologo} alt="Prestix" />
      </TopLineWrapper>
      
      {showValidation && leadGenHash ? (
        <LeadGenValidation
          hash={leadGenHash}
          onValidationSuccess={handleValidationSuccess}
          onValidationError={handleValidationError}
        />
      ) : (
        <UserForm />
      )}
      
      <Disclaimer>
        El período mínimo para la devolución de un préstamo es de 3 meses y el máximo es de 36 meses. Todos los préstamos son a tasa fija, en pesos y otorgados bajo el sistema de amortización francés con cuotas mensuales y consecutivas. La aprobación definitiva del préstamo está sujeta al cumplimiento de los requisitos solicitados por Corvalán 1160 S.A. Ejemplo: Monto solicitado de $20.000 a 12 meses | TNA (sin IVA): 150% - TEA (sin IVA): 311,44% - CFTNA (con IVA): 181,50% - CFTEA (con IVA): 442,05%* | Cuota: $3.648 | Total a pagar: $43.776. Este ejemplo no constituye una obligación de Corvalán 1160 S.A. de ofrecer dicha tasa ya que la Tasa Nominal Anual (TNA), la Tasa Efectiva Anual (TEA) y el Costo Financiero Total (CFT) de un préstamo varían dependiendo del perfil crediticio del solicitante. En todos los casos, la TNA, TEA y el CFT aplicable serán informados antes de la aceptación de la oferta de préstamo por parte del solicitante. La TNA mínima es de 150% y la máxima de 299%. A su vez, la TEA mínima es de 311,44% y la máxima de 1.349,07%. CFTEA con IVA: Mínimo: 442,05% - Máximo 2.262,09% CFTEA(*): 2.262,09% (*)IVA incluido
      </Disclaimer>
      <Footer />
    </Wrapper>
  );
};

export default withAuthAndData(Home);
